import { FC } from 'react';
import MainLayout from '@layouts/MainLayout';
import Campaigns from '@/components/page-components/campaigns';

const CampaignsPage: FC = () => {
  return (
    <MainLayout title="Campaigns" background="white" hideHeader>
      <Campaigns />
    </MainLayout>
  );
};

export default CampaignsPage;
